export default "__VITE_ASSET__qVFcUg3o__"